import {
  ClientSideSuspense,
  PKG_FORMAT,
  PKG_NAME,
  PKG_VERSION
} from "./chunk-JF4QXLDE.mjs";
import {
  ClientContext,
  LiveblocksProvider,
  RoomContext,
  _RoomProvider,
  _useAddReaction,
  _useBroadcastEvent,
  _useCreateThread,
  _useDeleteThread,
  _useEditThreadMetadata,
  _useEventListener,
  _useHistoryVersionsSuspense,
  _useInboxNotificationThread,
  _useIsInsideRoom,
  _useMutation,
  _useMyPresence,
  _useOtherSuspense,
  _useOthersListener,
  _useOthersMappedSuspense,
  _useOthersSuspense,
  _useRoom,
  _useRoomNotificationSettingsSuspense,
  _useSelfSuspense,
  _useStorageRoot,
  _useStorageSuspense,
  _useThreadsSuspense,
  _useUpdateMyPresence,
  _useUserSuspense,
  _useUserThreadsSuspense_experimental,
  useAttachmentUrlSuspense,
  useBatch,
  useCanRedo,
  useCanUndo,
  useClient,
  useCreateComment,
  useDeleteAllInboxNotifications,
  useDeleteComment,
  useDeleteInboxNotification,
  useEditComment,
  useErrorListener,
  useHistory,
  useInboxNotificationsSuspense,
  useLostConnectionListener,
  useMarkAllInboxNotificationsAsRead,
  useMarkInboxNotificationAsRead,
  useMarkThreadAsRead,
  useMarkThreadAsResolved,
  useMarkThreadAsUnresolved,
  useOthersConnectionIdsSuspense,
  useRedo,
  useRemoveReaction,
  useRoomInfoSuspense,
  useStatus,
  useStorageStatusSuspense,
  useThreadSubscription,
  useUndo,
  useUnreadInboxNotificationsCountSuspense,
  useUpdateRoomNotificationSettings
} from "./chunk-A7GJNN4L.mjs";

// src/suspense.ts
import { detectDupes } from "@liveblocks/core";
import { shallow } from "@liveblocks/client";
detectDupes(PKG_NAME, PKG_VERSION, PKG_FORMAT);
export {
  ClientContext,
  ClientSideSuspense,
  LiveblocksProvider,
  RoomContext,
  _RoomProvider as RoomProvider,
  shallow,
  _useAddReaction as useAddReaction,
  useAttachmentUrlSuspense as useAttachmentUrl,
  useBatch,
  _useBroadcastEvent as useBroadcastEvent,
  useCanRedo,
  useCanUndo,
  useClient,
  useCreateComment,
  _useCreateThread as useCreateThread,
  useDeleteAllInboxNotifications,
  useDeleteComment,
  useDeleteInboxNotification,
  _useDeleteThread as useDeleteThread,
  useEditComment,
  _useEditThreadMetadata as useEditThreadMetadata,
  useErrorListener,
  _useEventListener as useEventListener,
  useHistory,
  _useHistoryVersionsSuspense as useHistoryVersions,
  _useInboxNotificationThread as useInboxNotificationThread,
  useInboxNotificationsSuspense as useInboxNotifications,
  _useIsInsideRoom as useIsInsideRoom,
  useLostConnectionListener,
  useMarkAllInboxNotificationsAsRead,
  useMarkInboxNotificationAsRead,
  useMarkThreadAsRead,
  useMarkThreadAsResolved,
  useMarkThreadAsUnresolved,
  _useMutation as useMutation,
  _useMyPresence as useMyPresence,
  _useOtherSuspense as useOther,
  _useOthersSuspense as useOthers,
  useOthersConnectionIdsSuspense as useOthersConnectionIds,
  _useOthersListener as useOthersListener,
  _useOthersMappedSuspense as useOthersMapped,
  useRedo,
  useRemoveReaction,
  _useRoom as useRoom,
  useRoomInfoSuspense as useRoomInfo,
  _useRoomNotificationSettingsSuspense as useRoomNotificationSettings,
  _useSelfSuspense as useSelf,
  useStatus,
  _useStorageSuspense as useStorage,
  _useStorageRoot as useStorageRoot,
  useStorageStatusSuspense as useStorageStatus,
  useThreadSubscription,
  _useThreadsSuspense as useThreads,
  useUndo,
  useUnreadInboxNotificationsCountSuspense as useUnreadInboxNotificationsCount,
  _useUpdateMyPresence as useUpdateMyPresence,
  useUpdateRoomNotificationSettings,
  _useUserSuspense as useUser,
  _useUserThreadsSuspense_experimental as useUserThreads_experimental
};
//# sourceMappingURL=suspense.mjs.map